var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleMaleFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C11.337 2 10.7011 2.26339 10.2322 2.73223C9.76339 3.20107 9.5 3.83696 9.5 4.5C9.5 5.16304 9.76339 5.79893 10.2322 6.26777C10.7011 6.73661 11.337 7 12 7C12.3283 7 12.6534 6.93534 12.9567 6.8097C13.26 6.68406 13.5356 6.49991 13.7678 6.26777C13.9999 6.03562 14.1841 5.76002 14.3097 5.45671C14.4353 5.15339 14.5 4.8283 14.5 4.5C14.5 3.83696 14.2366 3.20107 13.7678 2.73223C13.2989 2.26339 12.663 2 12 2ZM10 8C8.9 8 8 8.89 8 10V18H9V22H11V18H13V22H15V18H16V10C16 8.89 15.1 8 14 8H10Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleMaleFigma);
export default __webpack_public_path__ + "static/media/single-male-figma.65b567e7989e0c9a0c193f12e69b0b18.svg";
export { ForwardRef as ReactComponent };